'use strict';

function isWebkit() {
  return 'WebkitAppearance' in document.documentElement.style;
}

module.exports = isWebkit;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/utils/isWebkit.js
 ** module id = 162
 ** module chunks = 0
 **/